import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, message, Radio, Row, Select } from 'antd';
import { connect } from 'react-redux';

import { queryApportionIsPublic } from '@api/finance/apportion';
import { queryDeleteAttachment } from '@api/pub/attachment';
import CompanySearch from '@comm/companySearch';
import UploadFile from '@comm/upload/UploadFile';
import ModalApportion from '@comm/apportion/ModalApportion';
import { BackBtn } from '@comm/BackBtn';
import { queryBudgetGroupCandF, queryBudgetGroupMy } from '@api/finance/budget';
import BudgetDescDoc from '../comm/showBudgetDescDoc';
import DescDoc from '../comm/showDescDoc';

const { Option } = Select;
const FormItem = Form.Item;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPublic: false,
      isRadio: '0',
      dataInfo: {},
      visible: false,
      group: [],
      groupTip: {},
      delFiles: [],
    };
  }

  componentDidMount() {
    const { data } = this.props;
    data.uuid && this.getBudgetGroupCandF(data.type);
    this.getBudgetGroup();
  }

  getBudgetGroup = () => {
    queryBudgetGroupMy().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          group: res.data,
        });
      }
    });
  };

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handSubmit, data } = this.props;
    const expenses = {
      ...data,
      ...this.props.form.getFieldsValue(),
    };
    if (this.apportion) {
      expenses.apportion = this.apportion;
    }
    this.props.form.validateFields((err, values) => {
      if (!err) {
        handSubmit(expenses);
        if (this.state.delFiles.length > 0) {
          this.state.delFiles.map(item => {
            queryDeleteAttachment({
              uuid: item.uuid,
            }).then(res => {});
            return item;
          });
        }
      }
    });
  };

  /**
   *文件删除
   */
  fileRemove = file => {
    const { delFiles } = this.state;
    delFiles.push(file);
    this.setState({ delFiles });
  };

  handleCompanyChange = (value, option) => {
    this.props.form.setFieldsValue({
      company: option.props.children,
    });
  };

  start = e => {
    this.submit(e, null, 'start');
  };

  getBudgetGroupCandF = value => {
    queryBudgetGroupCandF({
      userUuid: this.props.accountInfo.userUuid,
      type: value,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          groupTip: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  apportionIsPublic = value => {
    queryApportionIsPublic({
      type: value,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          isPublic: res.data.isPublic,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  handleTypeChange = (value, option) => {
    this.getBudgetGroupCandF(value);
    this.apportionIsPublic(value);
    this.props.form.setFieldsValue({
      typeName: option.props.children,
    });
  };

  handleBugetChange = e => {
    const data = this.props.form.getFieldsValue();
    if (data.type && data.price) {
      this.setState({
        dataInfo: data,
      });
      this.handleVisible(true);
    } else {
      message.info('请先将付款类型和付款金额填写完整！');
    }
  };

  handleRadioChange = e => {
    this.setState({
      isRadio: e.target.value,
    });
  };

  handleVisible = flag => {
    this.setState({
      visible: !!flag,
    });
  };

  handleOk = params => {
    this.apportion = params;
    this.handleVisible(false);
  };

  // 用款类型说明性title
  descTitle = () => {
    return (
      <span>
        付款类型
        <DescDoc />
      </span>
    );
  };

  // 预算来源说明性title
  descBudgetTitle = () => {
    return (
      <span>
        预算来源
        <BudgetDescDoc />
      </span>
    );
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    getFieldDecorator('company');
    getFieldDecorator('typeName');
    const ItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 12 },
    };
    const ItemLayout2 = {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
    };
    const { expendType, isSubmitting } = this.props;
    const { visible, dataInfo, group, groupTip, isPublic, isRadio } = this.state;
    const dataItem = this.props.data;
    return (
      <Form onSubmit={this.submit}>
        <div style={{ marginBottom: '16px' }}>
          <BackBtn />
          <Button
            icon="upload"
            type="primary"
            style={{ marginRight: 10 }}
            onClick={this.start}
            loading={isSubmitting}
          >
            发起申请
          </Button>
          {dataItem.uuid ? (
            <Button icon="delete" style={{ marginRight: 10 }} onClick={this.props.handleDelete}>
              删除
            </Button>
          ) : null}
        </div>
        <Card>
          <Row>
            <Col span={10} style={{ position: 'relative' }}>
              <Row>
                <FormItem label={this.descTitle()} {...ItemLayout}>
                  {getFieldDecorator('type', {
                    rules: [{ required: true, message: '请选择付款类型' }],
                    initialValue: dataItem.type,
                  })(
                    <Select
                      showSearch
                      onChange={this.handleTypeChange}
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {expendType.map(item => {
                        return <Option key={item.value}>{item.key}</Option>;
                      })}
                    </Select>,
                  )}
                </FormItem>
              </Row>
              <Row style={{ position: 'absolute', top: '35px', width: '100%' }}>
                <Col span={8} />
                <span>
                  {isRadio === '0' && groupTip.groupName ? (
                    <span style={{ color: 'red' }}>
                      该费用类型:{groupTip.groupName}可用余额
                      <span>{groupTip.current || 0}</span>元
                      {groupTip.freeze ? (
                        <span>
                          , 冻结
                          <span>{groupTip.freeze || 0}</span>
                        </span>
                      ) : null}
                    </span>
                  ) : null}
                </span>
              </Row>
            </Col>
            <Col span={10}>
              <FormItem label="付款金额" {...ItemLayout}>
                {getFieldDecorator('price', {
                  rules: [{ required: true, message: '请输入付款金额!' }],
                  initialValue: dataItem.price,
                })(<Input placeholder="付款金额" addonAfter="元" type="number" />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label={this.descBudgetTitle()} {...ItemLayout2}>
                {getFieldDecorator('budgetType', {
                  rules: [{ required: true, message: '请输入付款金额!' }],
                  initialValue: dataItem.budgetType ? '1' : '0',
                })(
                  <RadioGroup onChange={this.handleRadioChange}>
                    <RadioButton value="0">本部门预算</RadioButton>
                    <RadioButton value="1" onClick={this.handleBugetChange}>
                      跨部门预算
                    </RadioButton>
                    {group.map(item => (
                      <RadioButton value={item.value} key={item.value}>
                        {item.name}
                      </RadioButton>
                    ))}
                  </RadioGroup>,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="付款公司" {...ItemLayout2}>
                {getFieldDecorator('companyUuid', {
                  rules: [{ required: true, message: '请选择付款公司' }],
                  initialValue: dataItem.companyUuid,
                })(
                  <CompanySearch
                    companyName={dataItem.company}
                    companyUuid={dataItem.companyUuid}
                    onChange={this.handleCompanyChange}
                    {...this.props}
                  />,
                )}
              </FormItem>
            </Col>
            <Col span={20}>
              <FormItem label="收款方" {...ItemLayout2}>
                {getFieldDecorator('incomepart', {
                  rules: [{ required: true, message: '请填写收款方' }],
                  initialValue: dataItem.incomepart,
                })(<Input />)}
              </FormItem>
            </Col>
            <Col span={20}>
              <FormItem label="收款方账户" {...ItemLayout2}>
                {getFieldDecorator('account', {
                  rules: [{ required: true, message: '请填写收款方账户' }],
                  initialValue: dataItem.account,
                })(<Input />)}
              </FormItem>
            </Col>
            <Col span={20}>
              <FormItem label="收款方开户行" {...ItemLayout2}>
                {getFieldDecorator('bank', {
                  rules: [{ required: true, message: '请填写收款方开户行' }],
                  initialValue: dataItem.bank,
                })(<Input />)}
              </FormItem>
            </Col>
            <Col span={20}>
              <FormItem label="付款说明" {...ItemLayout2}>
                {getFieldDecorator('reason', {
                  initialValue: dataItem.reason,
                })(
                  <Input.TextArea
                    placeholder="备注"
                    type="textarea"
                    autosize={{ minRows: 3, maxRows: 9 }}
                    maxLength={1000}
                  />,
                )}
                <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入1000字</span>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="付款凭证" {...ItemLayout}>
                {getFieldDecorator('files', {
                  rules: [{ required: true, message: '请上传付款凭证' }],
                  initialValue: dataItem.files,
                })(
                  <UploadFile
                    type="ghost"
                    fileList={dataItem.file}
                    isPreview
                    onRemove={this.fileRemove}
                  />,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="申请人" {...ItemLayout}>
                {getFieldDecorator('crName', {
                  initialValue: dataItem.createUserName,
                })(<span>{this.props.accountInfo.userName}</span>)}
              </FormItem>
            </Col>
          </Row>
        </Card>
        <ModalApportion
          onCancel={this.handleVisible}
          dataInfo={dataInfo}
          dataItem={dataItem}
          isPublic={isPublic}
          visible={visible}
          onOk={this.handleOk}
          company={this.props.company}
          expendType={this.props.expendType}
        />
      </Form>
    );
  }
}

export default connect(state => ({
  expendType: state.expend_type,
  company: state.company_list,
  accountInfo: state.account_info,
}))(Form.create()(BaseForm));



// WEBPACK FOOTER //
// ./src/components/finance/payment/FormBase.js